import _ from 'lodash';
import React from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import {
  object, string, array,
} from 'yup';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormResource from '../FormResource.jsx';
import ListResource from '../../lists/ListResource.jsx';
import FieldArrayCards from '../FieldArrayCards.jsx';

const schema = object({
  name: string().required().label('Name'),
  colors: array().of(object({
    _id: string().required(),
  })).required().label('Color'),
});

const defaults = {
  name: '',
  colors: [],
};

export const ColorViewer = ({
  colors,
}) => {
  const [page, setPage] = React.useState(0);
  const count = colors?.length ?? 0;
  const totalPages = Math.max(1, Math.ceil(count / 40));
  React.useEffect(() => {
    const p = _.clamp(page, 0, totalPages);
    if (page !== p) setPage(p);
  }, [count, page]);
  return (
    <div className='container py-3'>
      <div className='row align-items-center'>
        <div className='col-auto'>
          <button
            className='btn'
            onClick={(e) => {
              e.preventDefault();
              if (page > 0) setPage(page - 1);
            }}
          >&lt;</button>
        </div>
        {_.map(_.chunk(colors ?? [], 40), (l, i) => (
          page === i && <div key={i} className='col container'>
            {_.map(_.chunk(l, 10), (x, j) => (
              <div key={j} className="row p-0">
                {_.map(x, (c, k) => (
                  <div
                    key={k}
                    className="col p-0"
                    style={{
                      flex: 1,
                      backgroundColor: c.hex,
                      aspectRatio: '1',
                    }}
                  />
                ))}
                {x.length < 10 && (
                  _.map(_.range(0, 10 - x.length), (k) => (
                    <div
                      key={k}
                      className="col p-0"
                      style={{
                        flex: 1,
                        aspectRatio: '1',
                      }}
                    />
                  ))
                )}
              </div>
            ))}
          </div>
        ))}
        <div className='col-auto'>
          <button
            className='btn'
            onClick={(e) => {
              e.preventDefault();
              if (page + 1 < totalPages) setPage(page + 1);
            }}
          >&gt;</button>
        </div>
      </div>
      <div className='row'>
        <div className='col-auto mx-auto'>
          {_.map(_.range(0, totalPages), (x) => (
            <span className={page === x ? 'text-primary' : 'text-muted'}>•</span>
          ))}
        </div>
      </div>
    </div>
  );
};

const FormPalette = ({
  palette,
}) => (
  <FormResource
    {...{
      schema,
      defaults,
      stored: palette,
      api: '/api/core/tfy/palettes',
      initialValuesOpts: { omitIds: false },
    }}
  >
    {({ values, setValues }) => (
      <Tabs defaultActiveKey="basic" unmountOnExit>
        <Tab eventKey="basic" title="Basic">
          <div className="pt-3">
            <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">BASIC</h6>
            <div className="row">
              <div className="col">
                <FormGroup name='name' label="Name" />
              </div>
              <div className="col">
              </div>
            </div>
          </div>
        </Tab>
        <Tab eventKey="colors" title="Colors">
          <div className="pt-3">
            <div className="row">
              <div className="col">
                <ListResource
                  {...{
                    searchable: true,
                    api: '/api/core/tfy/colors',
                    sort: { name: 1 },
                    actions: {
                      create: false,
                      remove: false,
                    },
                    onRowClick: (row) => {
                      setValues((v) => ({
                        ...v ?? {},
                        colors: [
                          ...v?.colors ?? [],
                          row,
                        ],
                      }));
                    },
                    cols: [
                      { key: 'name', sortable: true, children: 'Name' },
                      { key: 'pomId', sortable: true, children: 'Pom Id' },
                      { key: 'code', sortable: true, children: 'Color Code' },
                      { key: 'hex', sortable: true, children: 'Hex' },
                    ],
                  }}
                />
              </div>
              <div className="col">
                <ColorViewer colors={values?.colors} />
                <FieldArrayCards name="colors">
                  {(s, i) => (
                    <>
                      <div className="row">
                        <div className="col">
                          <FormGroup
                            name={`colors.${i}.name`}
                            label="Name"
                            disabled
                          />
                        </div>
                        <div className="col">
                          <FormGroup
                            name={`colors.${i}.hex`}
                            label="Hex"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <FormGroup
                            name={`colors.${i}.pomId`}
                            label="Pom Id"
                            disabled
                          />
                        </div>
                        <div className="col">
                          <FormGroup
                            name={`colors.${i}.code`}
                            label="Color Code"
                            disabled
                          />
                        </div>
                      </div>
                    </>
                  )}
                </FieldArrayCards>
              </div>
            </div>
          </div>
        </Tab>
      </Tabs>
    )}
  </FormResource>
);

export default FormPalette;
